import { marginGuardrailApi } from 'app/services/api';

import { createNamedActions } from 'utils/namedActionTypesProxy';

import { extractErrorMessage } from '../marginCenter.actionUtils';

export const GUARDRAIL_ACTION_TYPE = createNamedActions('marginCenter/guardrail', {
  SET_LOADING: 'SET_LOADING',
  SET_ERROR: 'SET_ERROR',
  GET_GUARDRAILS: 'GET_GUARDRAILS',
  SET_VERSIONS_LOADING: 'SET_VERSIONS_LOADING',
  SET_VERSIONS_ERROR: 'SET_VERSIONS_ERROR',
  GET_GUARDRAIL_VERSIONS: 'GET_GUARDRAIL_VERSIONS',
  SET_SAVING: 'SET_SAVING',
  SET_SAVE_ERROR: 'SET_SAVE_ERROR',
  UPSERT_GUARDRAIL: 'UPSERT_GUARDRAIL',
  SET_BUDGET_STATUS_LOADING: 'SET_BUDGET_STATUS_LOADING',
  SET_BUDGET_STATUS_ERROR: 'SET_BUDGET_STATUS_ERROR',
  GET_CONCESSION_BUDGET_STATUS: 'GET_CONCESSION_BUDGET_STATUS',
});

// The current row for every scope (company-wide + each channel) — one GET, no scope param.
export const getGuardrailsAction = () => async dispatch => {
  dispatch({ type: GUARDRAIL_ACTION_TYPE.SET_LOADING, payload: true });

  try {
    const { data } = await marginGuardrailApi.getCurrentForCompany();

    return dispatch({ type: GUARDRAIL_ACTION_TYPE.GET_GUARDRAILS, payload: data });
  } catch {
    return dispatch({ type: GUARDRAIL_ACTION_TYPE.SET_ERROR });
  }
};

// The version chain is keyed by the scope it was fetched FOR (channelId, or null = company-wide) — a
// scope switch never renders the previous scope's chain while the new one loads.
export const getGuardrailVersionsAction = channelId => async dispatch => {
  dispatch({ type: GUARDRAIL_ACTION_TYPE.SET_VERSIONS_LOADING, payload: true });

  try {
    const { data } = await marginGuardrailApi.getVersions(channelId);

    return dispatch({
      type: GUARDRAIL_ACTION_TYPE.GET_GUARDRAIL_VERSIONS,
      payload: { channelId: channelId ?? null, data },
    });
  } catch {
    return dispatch({ type: GUARDRAIL_ACTION_TYPE.SET_VERSIONS_ERROR });
  }
};

// Publishes a new guardrail-config version for the scope, superseding the prior current row. Returns the
// saved row on success, null on failure — the caller surfaces the reduced errorMessage inline.
export const createGuardrailVersionAction = request => async dispatch => {
  dispatch({ type: GUARDRAIL_ACTION_TYPE.SET_SAVING, payload: true });

  try {
    const { data } = await marginGuardrailApi.createVersion(request);

    dispatch({ type: GUARDRAIL_ACTION_TYPE.UPSERT_GUARDRAIL, payload: data });

    return data;
  } catch (error) {
    dispatch({ type: GUARDRAIL_ACTION_TYPE.SET_SAVE_ERROR, payload: extractErrorMessage(error) });

    return null;
  }
};

// DEV-4977/MC-10: the real computed cap-vs-consumed status per concession-budget scope for the Guardrails
// Concession Budgets tab — Consumed is server-computed (never persisted), so this replaces any client-side
// "sum the concession queue" approximation.
export const getConcessionBudgetStatusAction = channelId => async dispatch => {
  dispatch({ type: GUARDRAIL_ACTION_TYPE.SET_BUDGET_STATUS_LOADING, payload: true });

  try {
    const { data } = await marginGuardrailApi.getConcessionBudgetStatus(channelId);

    return dispatch({ type: GUARDRAIL_ACTION_TYPE.GET_CONCESSION_BUDGET_STATUS, payload: data });
  } catch {
    return dispatch({ type: GUARDRAIL_ACTION_TYPE.SET_BUDGET_STATUS_ERROR });
  }
};
